export default __webpack_public_path__ + "7797ae5b81b35231df9c1b6d8f2c4b0e.gif";